import React, { useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardMedia,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// import DeleteConfirmationModal from "./DeleteConfirmationModal";
import LockIcon from "@mui/icons-material/Lock";
import { useId } from "react";

const UserPhotosLayout = ({ photos, title, isEditable = false, showExtraCount = false, isPrivate = false, hideOnMobile, isTitleHide = true, classCardMedia, classTitlebg, classTitle, classTotalPhoto, height70Img }) => {
  const [deleteIndex, setDeleteIndex] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const galleryId = `gallery_` + useId();

useEffect(() => {
  Fancybox.bind(`[data-fancybox="${galleryId}"]`, {
    Thumbs: false,
    hideScrollbar: false,
  });

  return () => {
    Fancybox.unbind(`[data-fancybox="${galleryId}"]`);
  };
}, [galleryId,photos]);


  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
  };

  // const maxVisible = showExtraCount ? (isMobile ? 4 : 6) : photos.length;
  const maxVisible = isPrivate
    ? photos.length
    : showExtraCount
      ? (isMobile ? 4 : 6)
      : photos.length;
  // const photosToShow = photos.slice(0, maxVisible);
  const photosToShow = photos.slice(0, maxVisible);
  // const extraCount = showExtraCount && photos.length > maxVisible ? photos.length - maxVisible : 0;
  const extraCount =
    !isPrivate && showExtraCount && photos.length > maxVisible
      ? photos.length - maxVisible
      : 0;

  return (
    <Box>
      {/* Title */}
      {isTitleHide && (
        <Box className={classTitlebg} sx={{
          padding: { xs: '0 0 10px 0', sm: '24px 12px 18px 12px' }, display: hideOnMobile
            ? { xs: 'none', sm: 'flex' }
            : { xs: 'flex', sm: 'flex' }
        }} alignItems="center" justifyContent="space-between">
          <Typography className={classTitle} fontWeight={600} color="#6A513E" sx={{ fontSize: { xs: '18px', sm: '24px' } }}>{title}</Typography>
          <Typography className={classTotalPhoto} fontWeight={400} color="#3C4043" sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
            ({photos.length}) Photos
          </Typography>
        </Box>
      )}

      {/* Grid */}
      <Grid sx={{ padding: { xs: '0', sm: "0px 12px 0 12px" } }} container spacing={1}>
        {photosToShow.map((photo, index) => (
          <Grid item xs={6} sm={4} md={4} key={index}>
            <Card className={height70Img} sx={{ position: "relative", height: 170, overflow: "hidden" }}>
              <Box
                sx={{
                  position: "relative",
                  height: "100%",
                  "&:hover .hover-delete": {
                    opacity: isEditable ? 1 : 0,
                  },
                }}
              >

                <a
                  // href={!isPrivate ? photo : '#'}
                  // data-fancybox={!isPrivate ? "gallery" : undefined}
                  // onClick={(e) => {
                  //   if (isPrivate) e.preventDefault();
                  // }}
                   href={photo}
                  data-fancybox={galleryId }
                 
                >

                  <CardMedia
                    component="img"
                    className={classCardMedia}
                    image={photo}
                    // alt={photo}
                    onError={(e) => {
                        if (e.target.src.includes("broken-image.png")) return;
                        e.target.src = "/assets/images/broken-image.png";
                    }}
                    sx={{
                      cursor: photo ? "default" : "pointer",
                      height: "170px",
                      objectFit: "cover",
                      width: "100%",
                      filter: photo ? "blur(0px)" : "none",
                      '&:hover': { opacity: 0.9 },
                    }}
                  />
                </a>


                {isPrivate && !isEditable && !photo && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      bgcolor: "rgba(0,0,0,0.4)",
                      backdropFilter: "blur(4px)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 4,
                      color: "#fff",
                    }}
                  >
                    <LockIcon sx={{ fontSize: 32 }} />
                    <Typography sx={{ mt: 1, fontWeight: "400", fontSize: '14px', }}>Locked</Typography>
                  </Box>
                )}

                {photo?.loading && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      bgcolor: "rgba(255,255,255,0.8)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                    }}
                  >
                    <CircularProgress variant="determinate" value={photo.progress} />
                    <Typography sx={{ mt: 1 }}>{photo.progress}%</Typography>
                  </Box>
                )}

                {/* Extra image count on mobile */}
                {showExtraCount && extraCount > 0 && index === maxVisible - 1 && !isPrivate && (
                  <a
                    href={photos[maxVisible]}
                    data-fancybox={galleryId}
                    style={{ textDecoration: "none" }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: 24,
                        fontWeight: 700,
                        zIndex: 4,
                        borderRadius: 1,
                        cursor: "pointer",
                      }}
                    >
                      +{extraCount}
                    </Box>
                  </a>
                )}

                {/* Delete icon only when editable */}
                {isEditable && !photo?.loading && (
                  <Box
                    className="hover-delete"
                    onClick={() => handleDeleteClick(index)}
                    sx={{
                      position: "absolute",
                      bottom: "5px",
                      right: "5px",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      opacity: 0,
                      transition: "opacity 0.3s",
                      cursor: "pointer",
                      zIndex: 6,
                    }}
                  >
                    <DeleteIcon sx={{ fontSize: 18, color: "#000" }} />
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        ))}
       {/* Hidden anchors for Fancybox */}
        {photos?.length > maxVisible && photos.slice(maxVisible+1).map((photo, i) => (
          <a
            key={`hidden-${i}`}
            href={photo}
            data-fancybox={galleryId}
            style={{ display: "none" }}
          />
        ))}
      </Grid>


    </Box>
  );
};

export default UserPhotosLayout;
